import type AttendeeType from 'owa-service/lib/contract/AttendeeType';
import { convertRecipientsToAttendees } from 'owa-calendar-notes-editor/lib/utils/recipientAttendeeConversions';
import { getReadWriteRecipientViewStateFromFindRecipientPersonaType } from 'owa-recipient-create-viewstate/lib/util/getReadWriteRecipientViewStateFromFindRecipientPersonaType';
import { getRecipientsFromRequiredAttendees } from 'owa-calendar-compose-form-store/lib/utils/getRecipientsFromAttendees';
import { orchestrator } from 'satcheljs';
import {
    addPersonaToRequiredAttendees,
    updateRequiredAttendees,
} from 'owa-calendar-compose-form-actions';

export default orchestrator(addPersonaToRequiredAttendees, actionMessage => {
    let recipients = getRecipientsFromRequiredAttendees();
    recipients.push(
        getReadWriteRecipientViewStateFromFindRecipientPersonaType(actionMessage.persona)
    );
    const attendees: AttendeeType[] = convertRecipientsToAttendees(recipients);
    updateRequiredAttendees(attendees);
});
